module.exports = __webpack_public_path__ + "img/836-4a50e8.png";